import './assets/colors-development.scss';
import './assets/font.scss';
import './assets/others.scss';

const developmentGlobalStyle = () => {
    return 'development-mode';
};

export default developmentGlobalStyle;
